const BASE_URL = 'https://mymemorymentor.com/';

const APP_CONSTANTS = {
  API_URL: 'https://apptest.mymemorymentor.com/testamazeapi/index.php',  
  BASE_URL,
  TERMS_OF_SERVICES_URL: BASE_URL + 'termsofservice',
  PRIVACY_POLICY_URL: BASE_URL + 'privacy-policy',
  CONTACT_US_URL: BASE_URL + 'contact',
};

export default APP_CONSTANTS;